import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Highlight } from 'react-instantsearch';

import { formatContributors } from '../../../../helpers/content';
import useDates from '../../../../hooks/useDates';
import Card from '../../../Card';
import type { SearchAllContentNewsHit } from '../../types';

const SearchAllContentResultsNewsHit: React.FC<{ hit: SearchAllContentNewsHit }> = ({ hit }) => {
  const { t } = useTranslation();
  const { formatDate } = useDates();

  const datestring = useMemo(() => {
    if (!hit.date?.[0]) {
      return '';
    }

    const date = new Date(hit.date[0]);

    return formatDate(date);
  }, [formatDate, hit.date]);

  return (
    <Card
      className="SearchAllContent__Results__hit"
      url={hit.url[0]}
      label={t(`content_types.${hit.type[0]}.type`)}
      labelIcon="campaign"
      sublabel={datestring}
      title={<Highlight attribute="title" hit={hit} />}
      subtitle={formatContributors(hit.name)}
    />
  );
};

export default SearchAllContentResultsNewsHit;
